<template>
  <el-dialog
    title="修改人选类型"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="500px"
  >
    <el-form ref="lForm" :model="lObject" size="small" :rules="rules">
      <el-row>
        <el-col>
          <el-form-item prop="classPost">
            <el-select
              class="select-content"
              v-model="lObject.superiorStatus"
              placeholder="请选择人选类型"
            >
              <el-option
                v-for="(item, i) in memberTypeList"
                :key="i"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    memberTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      lObject: {
        superiorStatus: "",
      },
      rules: {
        superiorStatus: [
          {
            required: true,
            message: "请选择人选类型",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  mounted() {
    this.lObject.superiorStatus = this.dialogInfo.superiorStatus || null;
  },
  methods: {
    async confirmWay(msg) {
      try {
        const flag = await this.$confirm(msg, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        return flag !== "confirm";
      } catch (e) {
        return true;
      }
    },
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.$emit("close", false);
    },
    async submitForm() {
      if (await this.confirmWay("确认修改选中学员的人选类型吗？")) return;
      this.$refs["lForm"].validate((valid) => {
        if (valid) {
          this.$emit("close", true, this.lObject.superiorStatus);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-content {
  width: 100% !important;
}
</style>
